<template>
  <div class="page-container">
    <h3 class="title">401</h3>
    <p class="desc">Unauthorized error!</p>
    <p class="desc">Account is not authorized to access this page.</p>
  </div>
</template>

<script>
  export default {
    name: 'Unauthorized'
  };
</script>

<style lang="scss" scoped>
  .page-container {
    width: 100%;
    height: 100%;
    .title,
    .desc {
      display: block;
      margin: auto;
      width: 400px;
      margin-top: 100px;
    }
    .title {
      font-family: 'OpenSans-Regular';
      font-size: 50px;
      opacity: 0.9;
      text-shadow: #c3c1c1 0.1em 0.1em 0.2em;
      font-weight: bold;
      color: #898b96;
    }
  }
</style>
